import React, { Component } from "react";
import styled from "styled-components";
import * as Widget from "./Widget2";
import StepItem from "./StepItem";
import FindButton from "./FindButton";

const StepData = [
  {
    img: "step01",
    title: "尋喜愛的口味",
    description: "追求屬於自己最獨一無二的喜好。"
  },
  {
    img: "step02",
    title: "化口味為品味",
    description: "咖啡的選擇是一種美學生活態度。"
  },
  {
    img: "step03",
    title: "化品味為生活",
    description: "咖啡是陪伴你思考和放鬆的最好夥伴。"
  }
];

const FindData = [
  {
    img: "find01",
    title: "尋香氣",
    bgColor: "#BD9F84",
    link: "/aroma"
  },
  {
    img: "find02",
    title: "找焙度",
    bgColor: "#9E7A58",
    link: "/roast"
  },
  {
    img: "find03",
    title: "搜產地",
    bgColor: "#BD9F84",
    link: "/map"
  },
  {
    img: "find04",
    title: "覓店家",
    bgColor: "#755B41",
    link: "/stores"
  }
];

class FindFlavorSection extends Component {
  render() {
    return (
      <Wrapper>
        <Widget.SectionTitle>找到屬於你的品味</Widget.SectionTitle>
        <Widget.Row justify="center" wrap="true" css="margin: 25px 0px 40px;">
          {StepData.map((d, i) => (
            <StepItem key={"step-item" + i} data={d} number={i} />
          ))}
        </Widget.Row>
        <Widget.Row justify="center" wrap="true">
          {FindData.map((d, i) => (
            <FindButton key={"find-item" + i} data={d} />
          ))}
        </Widget.Row>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export default FindFlavorSection;
